import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var TextSizeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M15.4399 13.6299H18.83L26.65 34.3699H23.47L21.47 28.8499H12.76L10.76 34.3699H7.76001L15.4399 13.6299ZM17.0699 16.71L13.63 26.3699H20.55L17.0699 16.71ZM32.9 19.95H35.4301L35.5 20.0598L40.87 34.3599H38.35L37 30.6099H31.33L30 34.3599H27.5601L27.65 34.1299L32.9 19.95ZM34.12 22.7L32.02 28.5999H36.24L34.12 22.7Z"
  }));
});
TextSizeIcon.displayName = 'TextSizeIcon';
TextSizeIcon.defaultProps = {
  'aria-label': 'Text Size'
};
export default TextSizeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/TextSizeIcon/index.js
// module id = 1956
// module chunks = 12